import { render, staticRenderFns } from "./PrivacyIntro.vue?vue&type=template&id=52bc9e3d&scoped=true"
import script from "./PrivacyIntro.vue?vue&type=script&lang=js"
export * from "./PrivacyIntro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bc9e3d",
  null
  
)

export default component.exports